import * as React from "react";
import { Grid } from "@mui/material";
import PedidoTiendaForm from "../components/PedidoTiendaForm.js";
import { styles } from "../theme/styles";

function PedidoTienda() {
  return (
    <Grid style={styles.content3} container>
      <PedidoTiendaForm />
    </Grid>
  );
}

export default PedidoTienda;
